import React, { useState, useEffect, useCallback } from "react";
import MySwitch from "../../NavItems/Switch/Switch.component";
import FBXCalendar from "../../Universals/FBXCalendar/fbxcalendar.component.jsx";
import ModDropDown from "../../NavItems/ModDrop/ModDropDown.component.jsx";
import {
  CFLStatus,
  NFLStatus,
  ufl24Object,
  cflObject,
  nflObject,
  xfl23Object,
  aafObject,
  mlfbObject,
  uflObject,
  workingLeague,
  genPos,
  xflObject,
  usflObject,
} from "../../../utils/loadFunctions.ts";
import FBXYearPicker from "../../Universals/FBXYearPicker/fbxYearPicker.component.jsx";
import S1Input from "../../NavItems/S1input/S1Input.component.jsx";
import fbxlogoalone from "../../../assets/Logo/FBX-Gif.gif";

import { runS2Trans, runS2Event, runS2Scout, getTokenFromLocalStorage } from "../../../utils/functions.ts";
import { usePlayer } from "../../../Contexts/playerData.context.jsx";
import { useNavBar } from "../../../Contexts/navbar.items.context.jsx";
import { useDataLayer } from "../../../Contexts/DataLayer.context.jsx";
import { useS2Layer } from "../../../Contexts/S2Data.context.jsx";
import { runS2Note } from "../../../utils/functions.ts";
import RNFBox from "../../Universals/RNFBox/RNFBox.component.jsx";
import DragBox2026 from "../../Universals/DragBox/DragBox2026/dragBox2026.component.jsx";
import { getTodayEasternYMD } from "../../../utils/dateUtils.ts";

const normalizeS2Response = (theData) => {
  if (!theData || typeof theData !== "object") {
    return { count: 0, returnArray: [] };
  }

  const arr = Array.isArray(theData.returnArray) ? theData.returnArray : [];
  const rawCount = theData.count;

  return {
    count:
      rawCount === null || rawCount === undefined || rawCount === ""
        ? arr.length
        : Number(rawCount) || 0,
    returnArray: arr,
  };
};

const S2Box = () => {
  const { setSavedOriginalPlayerData, setPlayerData, setListLoadID, setPlayerID, setActivePlayer } = usePlayer();
  const { updateActiveSideButton } = useNavBar();
  const {
    positionArray,
    updateWhichOneLiner,
    eventArray,
    arrayOfShared,
    actualShared,
    triggerBlinkSQ,
  } = useDataLayer();

  const {
    savedTransArray,
    updateSavedTransArray,
    savedEventArray,
    updateSavedEventArray,
    savedScoutSearchArray,
    updateSavedScoutSearchArray,
  } = useS2Layer();

  const [eventSide, setEventSide] = useState([]);
  const [eventBlank, setEventBlank] = useState(false);
  const [transBlank, setTransBlank] = useState(false);
  const [scoutBlank, setScoutBlank] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const [s2Scouts, setS2Scouts] = useState([]);
  const [s2ScoutsLoaded, setS2ScoutsLoaded] = useState(false);

  const fetchS2Scouts = useCallback(async () => {
    try {
      const userRaw = await Promise.resolve(getTokenFromLocalStorage());
      const user =
        typeof userRaw === "string" ? userRaw : JSON.stringify(userRaw ?? {});

      const response = await fetch("https://www.fbxchange.com/ReactPHP/S2Search.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ method: "getS2Scouts", user }).toString(),
      });

      const data = await response.json().catch(() => null);

      let list = Array.isArray(data) ? data : Array.isArray(data?.scouts) ? data.scouts : [];

      const hasDash = list.some(
        (s) => String(s?.userId ?? s?.ID ?? "") === "-" || String(s?.displayName ?? "") === "-"
      );
      if (!hasDash) list = [{ displayName: "Select All", userId: "-" }, ...list];

      setS2Scouts(list);
      setS2ScoutsLoaded(true);
    } catch (e) {
      setS2Scouts([]);
      setS2ScoutsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchS2Scouts();
  }, [fetchS2Scouts]);

  const [chosenLeague, setChosenLeague] = useState([]);
  const [chosenPosition, setChosenPosition] = useState([]);
  const [chosenStatus, setChosenStatus] = useState([]);

  const resetDropdowns = () => {
    setDropdownOpen((prevState) =>
      Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {})
    );
  };

  const [dropdownOpen, setDropdownOpen] = useState({
    transLeague: false,
    chosenStatus: false,
    chosenPosition: false,
    chosenTeam: false,
    eventPosition: false,
    theEvent: false,
    theSide: false,
    chosenScout: false,
    scoutGenPosition: false,
    scoutExactPosition: false,
  });

  const handleDropdownToggle = (field, value, isOpen) => {
    setOpenCalendar(null);
    setSelectedYearPicker(null);
    setDropdownOpen((prev) => ({
      ...Object.keys(prev).reduce((acc, key) => {
        acc[key] = key === field ? isOpen : false;
        return acc;
      }, {}),
    }));
  };

  const S2SelectedItem = (field, value) => {
    setTransValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));

    if (field === "transLeague") {
      const leagueMappings = {
        CFL: { league: cflObject, position: genPos, status: CFLStatus },
        NFL: { league: nflObject, position: genPos, status: NFLStatus },
        UFL24: { league: ufl24Object, position: genPos, status: NFLStatus },
        XFL23: { league: xfl23Object, position: genPos, status: NFLStatus },
        EVENT: { league: eventArray, position: genPos, status: NFLStatus },
        USFL: { league: usflObject, position: genPos, status: NFLStatus },
        XFL: { league: xflObject, position: genPos, status: NFLStatus },
        AAF: { league: aafObject, position: genPos, status: NFLStatus },
        MLFB: { league: mlfbObject, position: genPos, status: NFLStatus },
        UFL: { league: uflObject, position: genPos, status: NFLStatus },
        "-": { team: "-", position: "-", status: "-" },
      };

      const mapping = leagueMappings[value];

      if (mapping) {
        if (value === "-") {
          updateTransValues("chosenTeam", mapping.team);
          updateTransValues("chosenStatus", mapping.status);
          updateTransValues("chosenPosition", mapping.position);
        } else {
          setChosenLeague(mapping.league);
          setChosenPosition(mapping.position);
          setChosenStatus(mapping.status);
        }
      }
    }
  };

  const runFirstSearch = async () => {
    setPlayerData([]);
    updateSavedTransArray(transValues);
    setIsSearching(true);
    setTransBlank(false);

    try {
      if (transValues.TransStartDate && transValues.TransEndDate) {
        const theData = await runS2Trans(transValues);
        const safeData = normalizeS2Response(theData);

        if (safeData.count > 0 && safeData.count < 1000 && safeData.returnArray.length > 0) {
          updateWhichOneLiner(null);
          setPlayerData(safeData.returnArray);
          setSavedOriginalPlayerData(safeData.returnArray);
          setPlayerID(safeData.returnArray[0].FBXID);
          setActivePlayer(safeData.returnArray[0]);
          updateActiveSideButton(null);
          const randomnum = Math.floor(Math.random() * 1_000_000) + 1;
          setListLoadID(randomnum);
          triggerBlinkSQ();
        } else if (safeData.count === 0) {
          setTransBlank(true);
        }
      }
    } catch (error) {
      console.error("Transaction search failed:", error);
      setTransBlank(true);
    } finally {
      setIsSearching(false);
    }
  };

  const [openCalendar, setOpenCalendar] = useState(null);

  const handleToggleCalendar = (fieldName) => {
    setSelectedYearPicker(null);
    resetDropdowns();
    if (openCalendar === fieldName) {
      setOpenCalendar(null);
      return;
    }
    setOpenCalendar(fieldName);
  };

  useEffect(() => {
    if (savedTransArray && Object.keys(savedTransArray).length > 0) {
      setTransValues(savedTransArray);
      if (savedTransArray.transLeague !== "-") {
        S2SelectedItem("transLeague", savedTransArray.transLeague);
      }
    }
  }, [savedTransArray]);

  const [transValues, setTransValues] = useState({
    TransStartDate: null,
    TransEndDate: null,
    transLeague: "-",
    chosenStatus: "-",
    chosenPosition: "-",
    chosenTeam: "-",
  });

  const resetValues = {
    TransStartDate: null,
    TransEndDate: null,
    transLeague: "-",
    chosenStatus: "-",
    chosenPosition: "-",
    chosenTeam: "-",
  };

  const updateTransValues = (field, value) => {
    setTransValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleDateChange = (field, value) => {
    updateTransValues(field, value);
    if (field === "TransStartDate") {
      if (transValues.TransEndDate === null) {
        updateTransValues("TransEndDate", value);
      }
    }
  };

  const resetFields = () => {
    setTransValues(resetValues);
    setOpenCalendar(null);
    updateSavedTransArray(resetValues);
    setTransBlank(false);
    setIsSearching(false);
  };

  const updateEventValues = (field, value) => {
    setEventValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (savedEventArray && Object.keys(savedEventArray).length > 0) {
      setEventValues(savedEventArray);
    }
  }, [savedEventArray]);

  const [eventValues, setEventValues] = useState(() => ({
    EventStart: null,
    EventEnd: null,
    eventPosition: "-",
    theEvent: "-",
    theSide: "-",
  }));

  const eventResetValues = {
    EventStart: null,
    EventEnd: null,
    eventPosition: "-",
    theEvent: "-",
    theSide: "-",
  };

  const [selectedYearPicker, setSelectedYearPicker] = useState(null);

  const handleYearChange = (field, value) => {
    updateEventValues(field, value);
    if (field === "EventStart" && (eventValues.EventEnd === "" || eventValues.EventEnd === null)) {
      updateEventValues("EventEnd", value);
    }
    setSelectedYearPicker(null);
  };

  const toggleYearPicker = (inval) => {
    resetDropdowns();
    setOpenCalendar(null);
    if (selectedYearPicker === inval) {
      setSelectedYearPicker(null);
      return;
    }
    setSelectedYearPicker(inval);
  };

  const S2EventFunction = async (field, value) => {
    const findSide = async (inval) => {
      try {
        updateEventValues("theSide", "-");
        const response = await fetch("https://www.fbxchange.com/ReactPHP/S2Search.php", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            method: "getTeamSide",
            sides: inval,
          }).toString(),
        });

        const data = await response.json();
        return data;
      } catch (error) {
        return null;
      }
    };

    updateEventValues(field, value);
    if (field === "theEvent") {
      const sideValues = await findSide(value);
      setEventSide(sideValues);
    }
  };

  const resetEvent = () => {
    setEventValues(eventResetValues);
    setEventSide([]);
    updateSavedEventArray(eventResetValues);
    setEventBlank(false);
    setIsSearching(false);
    setSelectedYearPicker(null);
  };

  const runSecondSearch = async () => {
    setPlayerData([]);
    setEventBlank(false);
    setIsSearching(true);
    updateSavedEventArray(eventValues);

    try {
      if (eventValues.EventStart) {
        const theData = await runS2Event(eventValues);
        const safeData = normalizeS2Response(theData);

        if (safeData.count > 0 && safeData.count < 1000 && safeData.returnArray.length > 0) {
          updateWhichOneLiner(null);
          setPlayerData(safeData.returnArray);
          setSavedOriginalPlayerData(safeData.returnArray);
          setPlayerID(safeData.returnArray[0].FBXID);
          setActivePlayer(safeData.returnArray[0]);
          updateActiveSideButton(null);
          const randomnum = Math.floor(Math.random() * 1_000_000) + 1;
          triggerBlinkSQ();
          setListLoadID(randomnum);
        } else if (safeData.count === 0) {
          setEventBlank(true);
        }
      }
    } catch (error) {
      console.error("Event search failed:", error);
      setEventBlank(true);
    } finally {
      setIsSearching(false);
    }
  };

  const [scoutValues, setScoutValues] = useState(() => ({
    chosenScout: "-",
    partThreeStart: null,
    PartThreeEnd: null,
    cflStart: null,
    cflEnd: null,
    nflStart: null,
    nflEnd: null,
    scoutGenPosition: "-",
    scoutExactPosition: "-",
    snpicker: true,
    isAvailable: false,
    isNational: false,
    global: false,
    theGrade: "",
    theMaxGrade: "",
  }));

  const scoutResetValues = {
    chosenScout: "-",
    partThreeStart: null,
    PartThreeEnd: null,
    cflStart: null,
    cflEnd: null,
    nflStart: null,
    nflEnd: null,
    scoutGenPosition: "-",
    scoutExactPosition: "-",
    snpicker: true,
    isAvailable: false,
    isNational: false,
    global: false,
    theGrade: "",
    theMaxGrade: "",
  };

  useEffect(() => {
    if (savedScoutSearchArray && Object.keys(savedScoutSearchArray).length > 0) {
      setScoutValues(savedScoutSearchArray);
      if (savedScoutSearchArray.scoutExactPosition !== "-") {
        setPurpleButton(false);
      }
    }
  }, [savedScoutSearchArray]);

  const updateScoutValues = (field, value) => {
    setScoutValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const SetScoutString = (field, value) => {
    updateScoutValues(field, value);
  };

  const handleScoutDateChange = (field, value) => {
    updateScoutValues(field, value);
    if (field === "partThreeStart") {
      if (scoutValues.PartThreeEnd === null) {
        const today = getTodayEasternYMD();
        updateScoutValues("PartThreeEnd", today);
      }
    }
  };

  const handleYearScoutChange = (field, value) => {
    updateScoutValues(field, value);
    if (field === "cflStart" && (scoutValues.cflEnd === "" || scoutValues.cflEnd === null)) {
      updateScoutValues("cflEnd", value);
    }
    if (field === "nflStart" && (scoutValues.nflEnd === "" || scoutValues.nflEnd === null)) {
      updateScoutValues("nflEnd", value);
    }
    setSelectedYearPicker(null);
  };

  const handleSwitchToggle = (title) => {
    if (title === "Reports") {
      if (scoutValues.snpicker) {
        updateScoutValues("snpicker", false);
        return;
      }
      updateScoutValues("snpicker", true);
    } else if (title === "Notes") {
      if (!scoutValues.snpicker) {
        updateScoutValues("snpicker", true);
        return;
      }
      updateScoutValues("snpicker", false);
      return;
    }
    switch (title) {
      case "isAvailable":
        updateScoutValues("isAvailable", !scoutValues.isAvailable);
        break;
      case "isNational":
        updateScoutValues("isNational", !scoutValues.isNational);
        break;
      case "global":
        updateScoutValues("global", !scoutValues.global);
        break;
      default:
        return;
    }
  };

  const resetScoutEvent = () => {
    setScoutValues(scoutResetValues);
    setScoutBlank(false);
    updateSavedScoutSearchArray(scoutResetValues);
    setIsSearching(false);
    setSelectedYearPicker(null);
    setOpenCalendar(null);
    resetDropdowns();
  };

  const runScoutSearch = async () => {
    setPlayerData([]);

    const scoutPayload = { ...scoutValues };
    if (scoutPayload.partThreeStart === null || scoutPayload.partThreeStart === "") {
      scoutPayload.partThreeStart = "1900-01-01";
      scoutPayload.PartThreeEnd = "2100-01-01";
    }

    setScoutBlank(false);
    setIsSearching(true);

    try {
      if (scoutPayload.partThreeStart || scoutPayload.chosenScout !== "-") {
        let theData = null;

        if (scoutPayload.snpicker) {
          theData = await runS2Scout(scoutPayload);
          updateWhichOneLiner("Scout");
        } else {
          theData = await runS2Note(scoutPayload);
          updateWhichOneLiner("Note");
        }

        const safeData = normalizeS2Response(theData);

        if (scoutPayload.partThreeStart === "1900-01-01") {
          scoutPayload.partThreeStart = null;
          scoutPayload.PartThreeEnd = null;
        }

        updateSavedScoutSearchArray(scoutPayload);

        if (safeData.count > 0 && safeData.count < 1000 && safeData.returnArray.length > 0) {
          setPlayerData(safeData.returnArray);
          setSavedOriginalPlayerData(safeData.returnArray);
          updateActiveSideButton(null);
          setPlayerID(safeData.returnArray[0].FBXID);
          setActivePlayer(safeData.returnArray[0]);

          const randomnum = Math.floor(Math.random() * 1_000_000) + 1;
          triggerBlinkSQ();
          setListLoadID(randomnum);
        } else if (safeData.count === 0) {
          setScoutBlank(true);
        }
      }
    } catch (error) {
      console.error("Error during runScoutSearch:", error);
      setScoutBlank(true);
    } finally {
      setIsSearching(false);
    }
  };

  const [purpleButton, setPurpleButton] = useState(true);

  const changePurpleButton = () => {
    setPurpleButton(!purpleButton);
    updateScoutValues("scoutGenPosition", "-");
    updateScoutValues("scoutExactPosition", "-");
  };

  const inputChange = (field, value) => {
    updateScoutValues(field, value);
  };

  return (
    <DragBox2026
      storageKey="S2SEARCH_DRAGBOX_POS_2026"
      defaultPos={{ x: 57, y: 95 }}
      title="Advanced S2 Search"
      headerLeft="Drag"
      onClose={() => updateActiveSideButton(null)}
      minWidth={1280}
      maxWidth={980}
      zIndex={999}
      showReset={true}
    >
      <div className="col-48 p-2">
        {isSearching ? (
          <div className="alert alert-light border shadow-sm p-3 text-center">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img src={fbxlogoalone} alt="" style={{ maxWidth: 140 }} />
              <div className="mt-2 fw-bold">
                Searching... If this Search takes longer than 15 seconds you can Cancel
              </div>
              <div className="mt-3 w-100" style={{ maxWidth: 420 }}>
                <button className="btn btn-danger w-100" onClick={() => setIsSearching(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="col-48 d-flex mb-2">
              <div className="ms-auto mb-2">
                <RNFBox buttonList={arrayOfShared} selectedButtons={actualShared} />
              </div>
            </div>

            <div className="alert alert-secondary p-2" id="S2One">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="fw-bold">
                  Transaction Search{" "}
                  <span className="fw-normal small text-muted">
                    You must choose a date Range to Begin Transaction Search
                  </span>
                </div>
                {transBlank && <div className="px-3 py-1 bg-warning-subtle border rounded fw-bold">0 Records Found</div>}
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                <FBXCalendar
                  fieldName="TransStartDate"
                  placeholder="Trans Start Date"
                  onDateChange={(value) => handleDateChange("TransStartDate", value)}
                  isOpen={openCalendar === "TransStartDate"}
                  dateIn={transValues.TransStartDate}
                  minYear="2015"
                  maxYear="2025"
                  style={{ width: "20%" }}
                  onToggleCalendar={handleToggleCalendar}
                />
                <FBXCalendar
                  fieldName="TransEndDate"
                  placeholder="Trans End Date"
                  onDateChange={(value) => handleDateChange("TransEndDate", value)}
                  isOpen={openCalendar === "TransEndDate"}
                  dateIn={transValues.TransEndDate}
                  minYear="2015"
                  maxYear="2025"
                  style={{ width: "20%" }}
                  onToggleCalendar={handleToggleCalendar}
                />

                {transValues.TransEndDate !== null && (
                  <ModDropDown
                    options={workingLeague}
                    field="League"
                    fieldValue="Value"
                    fieldName="transLeague"
                    isOpen={dropdownOpen.transLeague}
                    label="Transaction League"
                    value={transValues.transLeague}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => S2SelectedItem(field, value)}
                  />
                )}

                <div className="ms-auto d-flex gap-2">
                  <div className="btn btn-sm btn-success px-4 text-white" onClick={() => runFirstSearch()}>
                    Search
                  </div>
                  <div className="btn btn-sm btn-danger px-4" onClick={() => resetFields()}>
                    Refresh
                  </div>
                </div>
              </div>

              {transValues.transLeague !== "-" && (
                <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                  <ModDropDown
                    options={chosenLeague}
                    field="Team_Name"
                    fieldValue="Team"
                    fieldName="chosenTeam"
                    isOpen={dropdownOpen.chosenTeam}
                    label="Choose Team"
                    value={transValues.chosenTeam}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => S2SelectedItem(field, value)}
                  />
                  <ModDropDown
                    options={chosenStatus}
                    field="status"
                    fieldValue="status_id"
                    fieldName="chosenStatus"
                    isOpen={dropdownOpen.chosenStatus}
                    label="Choose Status"
                    value={transValues.chosenStatus}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => S2SelectedItem(field, value)}
                  />
                  <ModDropDown
                    options={chosenPosition}
                    field="title"
                    fieldValue="GeneralPos"
                    fieldName="chosenPosition"
                    isOpen={dropdownOpen.chosenPosition}
                    label="Choose Position"
                    value={transValues.chosenPosition}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => S2SelectedItem(field, value)}
                  />
                </div>
              )}
            </div>

            <div className="alert alert-secondary p-2" id="S2Two">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="fw-bold">
                  Event Search{" "}
                  <span className="fw-normal small text-muted">
                    You must choose a date Range to Begin Event Search
                  </span>
                </div>
                {eventBlank && <div className="px-3 py-1 bg-warning-subtle border rounded fw-bold">0 Records Found</div>}
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                <FBXYearPicker
                  placeholder="Start Year"
                  onYearChange={handleYearChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="EventStart"
                  style={{ width: "15%" }}
                  selectedYear={eventValues.EventStart}
                  isOpen={selectedYearPicker === "EventStart"}
                  onTogglePicker={() => toggleYearPicker("EventStart")}
                />
                <FBXYearPicker
                  placeholder="End Year"
                  onYearChange={handleYearChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="EventEnd"
                  style={{ width: "15%" }}
                  selectedYear={eventValues.EventEnd}
                  isOpen={selectedYearPicker === "EventEnd"}
                  onTogglePicker={() => toggleYearPicker("EventEnd")}
                />

                <ModDropDown
                  options={genPos}
                  field="title"
                  fieldValue="GeneralPos"
                  fieldName="eventPosition"
                  isOpen={dropdownOpen.eventPosition}
                  label="Pro Gen Position"
                  value={eventValues.eventPosition}
                  onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                  onSelect={(field, value) => S2EventFunction(field, value)}
                  percent="15%"
                />

                <ModDropDown
                  options={eventArray}
                  field="Team_Name"
                  fieldValue="Team"
                  fieldName="theEvent"
                  isOpen={dropdownOpen.theEvent}
                  label="Choose Event"
                  value={eventValues.theEvent}
                  onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                  onSelect={(field, value) => S2EventFunction(field, value)}
                  percent="15%"
                />

                {eventSide.length > 0 && (
                  <ModDropDown
                    options={eventSide}
                    field="SIDE"
                    fieldValue="SIDE"
                    fieldName="theSide"
                    isOpen={dropdownOpen.theSide}
                    label="Choose Side"
                    value={eventValues.theSide}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => S2EventFunction(field, value)}
                    percent="15%"
                  />
                )}

                <div className="ms-auto d-flex gap-2">
                  <div className="btn btn-sm btn-success px-4 text-white" onClick={() => runSecondSearch()}>
                    Search
                  </div>
                  <div className="btn btn-sm btn-danger px-4" onClick={() => resetEvent()}>
                    Refresh
                  </div>
                </div>
              </div>
            </div>

            <div className="alert alert-secondary p-2" id="S2Three">
              <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                <div className="fw-bold">Scout Reports // Notes Search</div>
                {scoutBlank && <div className="px-3 py-1 bg-warning-subtle border rounded fw-bold">0 Records Found</div>}
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap mb-2">
                <ModDropDown
                  options={s2Scouts}
                  field="displayName"
                  fieldValue="userId"
                  fieldName="chosenScout"
                  isOpen={dropdownOpen.chosenScout}
                  label={s2ScoutsLoaded ? "All Scouts" : "Loading Scouts..."}
                  value={scoutValues.chosenScout}
                  onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                  onSelect={(field, value) => SetScoutString(field, value)}
                  percent="20%"
                />

                <FBXCalendar
                  fieldName="partThreeStart"
                  placeholder="Start Date"
                  onDateChange={(value) => handleScoutDateChange("partThreeStart", value)}
                  isOpen={openCalendar === "partThreeStart"}
                  dateIn={scoutValues.partThreeStart}
                  minYear="2015"
                  maxYear="2025"
                  style={{ width: "20%" }}
                  onToggleCalendar={handleToggleCalendar}
                />

                <FBXCalendar
                  fieldName="PartThreeEnd"
                  placeholder="End Date"
                  onDateChange={(value) => handleScoutDateChange("PartThreeEnd", value)}
                  isOpen={openCalendar === "PartThreeEnd"}
                  dateIn={scoutValues.PartThreeEnd}
                  minYear="2015"
                  maxYear="2025"
                  style={{ width: "20%" }}
                  onToggleCalendar={handleToggleCalendar}
                />

                <div className="ms-auto d-flex gap-2">
                  <div className="btn btn-sm btn-success px-4 text-white" onClick={() => runScoutSearch()}>
                    Search
                  </div>
                  <div className="btn btn-sm btn-danger px-4" onClick={() => resetScoutEvent()}>
                    Refresh
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                <FBXYearPicker
                  placeholder="CFL Start"
                  onYearChange={handleYearScoutChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="cflStart"
                  style={{ width: "9.5%" }}
                  selectedYear={scoutValues.cflStart}
                  isOpen={selectedYearPicker === "cflStart"}
                  onTogglePicker={() => toggleYearPicker("cflStart")}
                />
                <FBXYearPicker
                  placeholder="CFL End"
                  onYearChange={handleYearScoutChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="cflEnd"
                  style={{ width: "10%" }}
                  selectedYear={scoutValues.cflEnd}
                  isOpen={selectedYearPicker === "cflEnd"}
                  onTogglePicker={() => toggleYearPicker("cflEnd")}
                />
                <FBXYearPicker
                  placeholder="NFL Start"
                  onYearChange={handleYearScoutChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="nflStart"
                  style={{ width: "9.5%" }}
                  selectedYear={scoutValues.nflStart}
                  isOpen={selectedYearPicker === "nflStart"}
                  onTogglePicker={() => toggleYearPicker("nflStart")}
                />
                <FBXYearPicker
                  placeholder="NFL End"
                  onYearChange={handleYearScoutChange}
                  minYear="2008"
                  maxYear="2030"
                  fieldName="nflEnd"
                  style={{ width: "10%" }}
                  selectedYear={scoutValues.nflEnd}
                  isOpen={selectedYearPicker === "nflEnd"}
                  onTogglePicker={() => toggleYearPicker("nflEnd")}
                />

                {purpleButton ? (
                  <ModDropDown
                    options={genPos}
                    field="title"
                    fieldValue="GeneralPos"
                    fieldName="scoutGenPosition"
                    isOpen={dropdownOpen.scoutGenPosition}
                    label="Pro Gen Position"
                    value={scoutValues.scoutGenPosition}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => SetScoutString(field, value)}
                    percent="20%"
                  />
                ) : (
                  <ModDropDown
                    options={positionArray}
                    field="POS_DESC"
                    fieldValue="POS_SPEC_CODE"
                    fieldName="scoutExactPosition"
                    isOpen={dropdownOpen.scoutExactPosition}
                    label="Pro Exact Position"
                    value={scoutValues.scoutExactPosition}
                    onDropdownToggle={(field, value, isOpen) => handleDropdownToggle(field, value, isOpen)}
                    onSelect={(field, value) => SetScoutString(field, value)}
                    percent="20%"
                  />
                )}

                <button
                  className={`btn btn-sm text-white px-4 ${purpleButton ? "btn-purple" : "btn-warning"}`}
                  onClick={() => changePurpleButton()}
                >
                  X or GP
                </button>

                {scoutValues.snpicker && (
                  <>
                    <S1Input
                      onKeyUpChange={(value) => inputChange("theGrade", value)}
                      placeholder="Min Grade"
                      percent="10%"
                      value={scoutValues.theGrade}
                    />
                    <S1Input
                      onKeyUpChange={(value) => inputChange("theMaxGrade", value)}
                      placeholder="Max Grade"
                      percent="10%"
                      value={scoutValues.theMaxGrade}
                    />
                  </>
                )}
              </div>

              <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                <div>Reports:</div>
                <MySwitch isOn={scoutValues.snpicker} title="Reports" onClick={handleSwitchToggle} />
                <div>Notes:</div>
                <MySwitch isOn={!scoutValues.snpicker} title="Notes" onClick={handleSwitchToggle} />

                <div className="ms-4">Available:</div>
                <MySwitch isOn={scoutValues.isAvailable} title="isAvailable" onClick={handleSwitchToggle} />

                <div className="ms-4">National:</div>
                <MySwitch isOn={scoutValues.isNational} title="isNational" onClick={handleSwitchToggle} />

                <div className="ms-4">Global:</div>
                <MySwitch isOn={scoutValues.global} title="global" onClick={handleSwitchToggle} />
              </div>
            </div>
          </div>
        )}
      </div>
    </DragBox2026>
  );
};

export default S2Box;
